import Api from "./Api";
import { WidgetTour } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class WidgetToursController extends Api {
  static getTour(widgetId: string, id: string) {
    return fetch(`/api/widgets/${widgetId}/tours/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getTours(widgetId: string, params: object = {}) {
    return fetch(
      `/api/widgets/${widgetId}/tours?${SearchHelper.getQueryString(params)}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static create(widgetId: string, tour: Partial<WidgetTour>) {
    return fetch(`/api/widgets/${widgetId}/tours`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ tour: tour }),
    }).then((res) => res.json());
  }

  static update(widgetId: string, tour: Partial<WidgetTour>) {
    return fetch(`/api/widgets/${widgetId}/tours/${tour.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ tour: tour }),
    }).then((res) => res.json());
  }

  static delete(widgetId: string, id: string) {
    return fetch(`/api/widgets/${widgetId}/tours/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static createBuilderToken(widgetId: string, tourId: string): Promise<{ token: string, start_url: string | null }> {
    return fetch(`/api/widgets/${widgetId}/tours/${tourId}/builder_token`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static deleteAll(widgetId: string, ids: string[]) {
    return fetch(`/api/widgets/${widgetId}/tours/destroy_all`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ ids }),
    }).then((res) => res.json());
  }
}
